module.exports = __webpack_public_path__ + "img/pr-1.220755d1.png";